import { useQuery } from '@tanstack/react-query';
import { GetTagsParams } from '@src/api/common.ts';
import { API } from '@src/api/index.ts';

export const useTagsQuery = (params: GetTagsParams) => {
  return useQuery({
    queryFn: async () => await API.common.getTags(params),
    queryKey: ['tags', params],
    initialData: [],
    enabled: typeof params?.partition !== 'undefined',
  });
};
